import React, { useState } from 'react';
import { Button, Text } from '@opendoor/bricks/core';

interface LongTextProps {
  content: string;
  limit: number;
}

const LongText: React.FC<LongTextProps> = ({ content, limit }) => {
  const [showAll, setShowAll] = useState(false);

  const showMore = () => setShowAll(true);
  const showLess = () => setShowAll(false);

  if (content?.length <= limit) {
    return (
      <Text fontSize="s1" lineHeight="s2">
        {content}
      </Text>
    );
  }
  return (
    <Text fontSize="s1" lineHeight="s2">
      {showAll ? content : content.substring(0, limit) + '...'}
      <Button
        analyticsName="cosmos-long-text-read"
        aria-label={null}
        onClick={showAll ? showLess : showMore}
        variant="inline-secondary-link"
        backgroundColor="transparent"
        padding={0}
        height="auto"
        width="auto"
        ml={showAll ? '3' : '0'}
      >
        {showAll ? 'Read less' : 'Read more'}
      </Button>
    </Text>
  );
};

export default LongText;
